import React from 'react'

const Footer = () => {
    return (
        <footer>
            <p className="cont">
                <a
                    id="weather"
                    href="https://www.instagram.com/explore/tags/weather/"
                    target="_blank"
                    rel="noreferrer"
                >
                    #Weather
                </a>
                <br />
                <span className="material-symbols-outlined">ac_unit</span>
            </p>
        </footer>
    );
};

export default Footer;